import axios from 'axios';
import { API_BASE_URL } from './utils';

const API_URL = API_BASE_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      // If user is on superadmin section, redirect to superadmin login
      if (window.location.pathname.startsWith('/superadmin')) {
        window.location.href = '/superadmin/login';
      } else {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const authAPI = {
  login: (data) => api.post('/admin/auth/login', data),
  mobileRegister: (data) => api.post('/mobile/auth/registerPhone', data),
  mobileLogin: (data) => api.post('/mobile/auth/login', data),
  mobileCreateProfile: (data) => api.post('/mobile/auth/createProfile', data),
  mobileGetProfile: () => api.get('/mobile/auth/getProfile'),
  getLanguages: () => api.get('/mobile/auth/getLanguages'),
  getDiscounts: () => api.get('/mobile/auth/getDiscount'),
};

// Customers
export const customersAPI = {
  getAll: (params) => api.get('/admin/customers', { params }),
  getOne: (id) => api.get(`/admin/customers/${id}`),
  update: (id, data) => api.put(`/admin/customers/${id}/basic`, data),
  delete: (id) => api.delete(`/admin/customers/${id}`),
  getStats: (id) => api.get(`/admin/customers/${id}/stats`),
};

// Food
export const foodAPI = {
  getCategories: () => api.get('/admin/food/categories'),
  createCategory: (data) => api.post('/admin/food/categories', data),
  updateCategory: (id, data) => api.put(`/admin/food/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/admin/food/categories/${id}`),
  getItems: (params) => api.get('/admin/food/items', { params }),
  createItem: (data) => api.post('/admin/food/items', data),
  updateItem: (id, data) => api.put(`/admin/food/items/${id}`, data),
  deleteItem: (id) => api.delete(`/admin/food/items/${id}`),
  getMobileCategories: () => api.get('/mobile/food/getFoodCategory'),
};

// Groups
export const groupsAPI = {
  getAll: () => api.get('/admin/groups'),
  create: (data) => api.post('/admin/groups', data),
  update: (id, data) => api.put(`/admin/groups/${id}`, data),
  delete: (id) => api.delete(`/admin/groups/${id}`),
};

// Chat
export const chatAPI = {
  getRooms: (params) => api.get('/admin/chat/rooms', { params }),
  getMessages: (params) => api.get('/admin/chat/messages', { params }),
};

// Meal Times
export const mealTimesAPI = {
  getAll: () => api.get('/admin/meal-times'),
};

// Agents
export const agentsAPI = {
  getAll: () => api.get('/admin/agents'),
  create: (data) => api.post('/admin/agents', data),
  update: (id, data) => api.put(`/admin/agents/${id}`, data),
  delete: (id) => api.delete(`/admin/agents/${id}`),
};

// Partners
export const partnersAPI = {
  getAll: () => api.get('/admin/partners'),
  create: (data) => api.post('/admin/partners', data),
  update: (id, data) => api.put(`/admin/partners/${id}`, data),
  delete: (id) => api.delete(`/admin/partners/${id}`),
};

// Resellers
export const resellersAPI = {
  getAll: () => api.get('/admin/resellers'),
  create: (data) => api.post('/admin/resellers', data),
  update: (id, data) => api.put(`/admin/resellers/${id}`, data),
  delete: (id) => api.delete(`/admin/resellers/${id}`),
};

// Health check
export const healthAPI = {
  check: () => api.get('/'),
};

export default api;
